import React, { useEffect, useState } from 'react';
import AOS from 'aos'; // AOS 스크립트 파일을 임포트
import heroImage from '../../assets/imgs/companyHero.webp';
import crossCard1 from '../../assets/imgs/crossCard1.jpg';
import crossCard2 from '../../assets/imgs/crossCard2.jpg';
import crossCard3 from '../../assets/imgs/crossCard3.jpg';
import crossCard4 from '../../assets/imgs/crossCard4.jpg';
import crossCard5 from '../../assets/imgs/crossCard5.jpg';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import KakaoMapWithAddress from '../../components/kakao/KakaoMap';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const historyData = [
  {
    year: '2025',
    issues: [
      {
        month: '-',
        content: 'KISA 위치정보사업자를 위한 클라우드 서비스 지원',
        accent: true,
      },
      {
        month: '-',
        content: '대전교통공사 타슈 시스템 클라우드 서비스 지원',
        accent: true,
      },
      {
        month: '-',
        content: '평택시 탄소중립 통합 솔루션 구축 클라우드 서비스 지원',
        accent: true,
      },
      {
        month: '-',
        content: 'KISA 키사아카데미 교육훈련시스템 클라우드 서비스 지원',
        accent: true,
      },
      {
        month: '-',
        content: '아정당 MVNO 클라우드 서비스 지원',
      },
      {
        month: '-',
        content: '와이드모바일 MVNO 클라우드 서비스 지원',
      },
    ],
  },
  {
    year: '2024',
    issues: [
      {
        month: '-',
        content: 'KISA 전자문서유통허브 클라우드 서비스',
        accent: true,
      },
      {
        month: '-',
        content: '배달서비스 공제조합 "공제인프라 클라우드서비스"',
      },
      {
        month: '-',
        content: '비피그룹 "원신게임 클라우드서비스"',
      },
      {
        month: '-',
        content:
          'KISA 아세안 사이버 쉴드 온라인 교육 및 해킹방어대회 시스템 개발용역 클라우드 서비스',
        accent: true,
      },
      {
        month: '-',
        content: 'KISA 가명정보 활용 지원체계 통합 운영 인프라 임차',
        accent: true,
      },
    ],
  },
  {
    year: '2023~ \t 2018',
    issues: [
      {
        month: '-',
        content:
          'KISA 아세안 사이버쉴드 온라인 교육 및 해킹방어대회 시스템 개발용역 클라우드 서비스',
        accent: true,
      },
      {
        month: '-',
        content:
          'KISA 가명정보 지원시스템 인프라 통합을 위한 자산구매 개발환경 IDC 서비스',
        accent: true,
      },
      {
        month: '-',
        content: '데이터산업진흥원 마이데이타 시범사업',
      },
      {
        month: '-',
        content: '배달서비스 공제회 시스템 개발용역 클라우드 서비스',
      },
      {
        month: '-',
        content: '티맥스 클라우드 MSP 지원 사업',
      },
      {
        month: '-',
        content: '원광대학병원 통합의료정보시스템 HW구축 기술지원',
      },
      {
        month: '-',
        content: '쿠도커뮤니케이션 백신서비스 IDC 인프라 제공',
      },
      {
        month: '-',
        content: '다날 인프라랩 CDN인프라 IDC 서비스',
      },
      {
        month: '-',
        content: 'NHN클라우드 Platinum Partner 획득',
      },
    ],
  },
  {
    year: '2022~ \t 2021',
    issues: [
      {
        month: '-',
        content: 'CDN서비스 런칭',
      },
      {
        month: '-',
        content: '모바일 웹 게임 타짱 서비스 진행',
      },
      {
        month: '-',
        content: '브로드밴드아이디씨 50Gbps 트래픽 서비스 제공',
      },
    ],
  },
  {
    year: '2020~ \t 2016',
    issues: [
      {
        month: '-',
        content: 'SKB 서초 1센터에 IDC 서비스 OPEN',
      },
      {
        month: '-',
        content:
          '2016.12 부가통신업 및 소프트웨어 개발 목적으로 (주)디엔에이클라우드 설립',
      },
    ],
  },
];

function CompanyMain({ firstSectionRef }) {
  const [currentYear, setCurrentYear] = useState('2023'); // 현재 표시되는 연도
  const [currentYearIndex, setCurrentYearIndex] = useState(1);
  const [isHistory, setIsHistory] = useState(false);
  const [isHistoryLastDirection, setIsHistoryLastDirection] = useState('top');

  // 스크롤 이벤트 처리
  useEffect(() => {
    const handleScroll = () => {
      const historyWrap = document.querySelectorAll('.issueList');
      const issueWraps = document.querySelectorAll('.issueWrap');
      let year = currentYear;
      historyWrap.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          setIsHistory(true);
        } else {
          setIsHistory(false);
        }
        if (rect.top >= window.innerHeight / 2) {
          setIsHistoryLastDirection('top');
        }
        if (rect.bottom <= window.innerHeight / 2) {
          setIsHistoryLastDirection('bottom');
        }
      });
      issueWraps.forEach((wrap, i) => {
        const rect = wrap.getBoundingClientRect();
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          year = wrap.querySelector('.year span').innerText;
          setCurrentYearIndex(i + 1);
        }
      });

      setCurrentYear(year);
    };

    window.addEventListener('scroll', handleScroll);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentYear]);

  useEffect(() => {
    AOS.init({
      duration: 1000, // 애니메이션 지속 시간 (ms)
      easing: 'ease-out', // 애니메이션 이징 함수
      once: false, // 스크롤 후 한 번만 애니메이션 실행
    });
  }, []);
  return (
    <div className="companyMainPageWrapper">
      <div
        data-aos="fade"
        data-aos-delay="0"
        data-aos-offset="0"
        ref={firstSectionRef}
        className="companyHeroSection"
      >
        <div className="heroItem flex-col align-center justify-center">
          <div className="subHeroImage">
            <img src={heroImage} alt="" />
          </div>
          <div className="grid flex-col tab:align-start justify-center align-center">
            <div className="flex-col tab:text-start gap-48 justify-center align-center">
              <div className="mainText tab:text-start">
                <span className={'tab:text-start'}>
                  <strong>CLOUD INNOVATION</strong>
                  <br />
                  THAT CONNECTS THE FUTURE
                </span>
              </div>
              <div className="descriptionWrap tab:flex-col flex-row gap-32">
                <div className="main">
                  <span className={'tab:text-start'}>
                    Your Trusted Partner in
                    <br />
                    Digital Transformation
                  </span>
                </div>
                <div className="sub tab:text-start">
                  <span className={'tab:text-start'}>
                    IT 기술은 물리적 한계를 넘어 가상 공간으로 확장되었으며,
                    데이터와 AI 기술을 현실로 만들었습니다. 빠르게 변화하는
                    디지털 시대, 클라우드는 기업 경쟁력의 핵심입니다.
                    <br />
                    디엔에이클라우드는 혁신적인 클라우드 서비스로 고객
                    비즈니스를 최적화하고, 미래를 예측하며, 변화에 유연하게
                    대응할 수 있도록 지원합니다. 최고의 IT 인프라와 솔루션을
                    통해 지속 가능한 성장을 함께 이루어가겠습니다.
                    <br />
                    클라우드의 무한한 가능성을 현실로, 고객과 함께 미래를
                    설계합니다.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="sloganSectionType2 py-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col tab:align-start gap-32 align-center justify-center">
          <div className="divide"></div>
          <div className="textWrap tab:text-start flex-col gap-32 justify-center align-center">
            <div className="main tab:text-start">
              <span className={'tab:text-start'}>
                <strong>
                  디지털 전환의 든든한 파트너, 디엔에이클라우드
                  <br />
                </strong>
                클라우드부터 IDC, 보안까지, 통합 IT 인프라 서비스 제공
              </span>
            </div>
            <div className="sub tab:text-start">
              <span>
                디엔에이클라우드는 NHN 클라우드 PLATINUM 파트너로서 클라우드
                아키텍처 설계 및 CSP 전환 사업을 성공적으로 수행하며,
                <br /> MSP 역할부터 서버 호스팅·코로케이션·CDN까지 맞춤형 인프라
                서비스를 제공합니다.
                <br />
                국내 주요 통신사 회선을 연동한 안정적인 IDC 환경, 실시간
                스트리밍을 위한 Wowza 전문 호스팅, 자체 보안 시스템 기반의 DDoS
                방어 및 운영 관제 서비스까지 — 고객의 인프라 전환과 운영을 통합
                지원합니다.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="companyStrongSection py-96 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-16 align-center justify-center">
          <div className="pathItemWrap mob:flex-col first br-ltb flex-row gap-16">
            <div className="pathItem  first br-ltb accent-bg accent-color flex-row align-center justify-center py-24 px-24">
              <div className="textWrap  flex-row gap-16 align-center justify-center">
                <div className="number">
                  <span>01</span>
                </div>
                <div className="main">
                  <span>
                    NHN Cloud 최고 등급 파트너,
                    <br />
                    검증된 MSP 전문 기업
                  </span>
                </div>
              </div>
            </div>
            <div className="pathItem br-tlr flex-row align-center justify-center py-24 px-24">
              <div className="textWrap flex-row gap-16 align-center justify-center">
                <div className="number">
                  <span>02</span>
                </div>
                <div className="main">
                  <span>
                    고성능 · 고가용 <br />
                    IDC 인프라 기반
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="pathItemWrap mob:flex-col last flex-row gap-16">
            <div className="pathItem br-tlr accent-color flex-row align-end justify-end py-24 px-24">
              <div className="textWrap  flex-row gap-16 align-center justify-center">
                <div className="number">
                  <span>03</span>
                </div>
                <div className="main">
                  <span>
                    경험 많은 인프라 <br />
                    전문가 구성
                  </span>
                </div>
              </div>
            </div>
            <div className="pathItem last  br-ltb flex-row align-end justify-end py-24 px-24">
              <div className="textWrap flex-row gap-16 align-center justify-center">
                <div className="number">
                  <span>04</span>
                </div>
                <div className="main">
                  <span>
                    클라우드부터 보안까지,
                    <br />
                    통합 IT 인프라 서비스 제공
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="whyDnaSection flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-128 align-center justify-center">
          <div className="flex-col  gap-32 tab:align-start align-center justify-center">
            <div className="divide"></div>
            <div className="textWrap flex-col tab:align-start gap-32 justify-center align-center">
              <div className="main tab:text-start">
                <span className={'tab:text-start'}>WHY D&A CLOUD</span>
              </div>
              <div className="sub tab:text-start">
                <span>
                  고객에게 최고의 인터넷비즈니스환경을 제공하여 고객이 본연의
                  서비스에
                  <br /> 충실할 수 있도록함으로서 고객과 디엔에이클라우드 모두가
                  WIN-WIN 하는서비스제공합니다
                </span>
              </div>
            </div>
          </div>
          <div className="crossCardWrap">
            <div className="cross-grid   gap-16">
              <div className="grid-item  py-20 px-20 top">
                <div className="imgWrap">
                  <img src={crossCard1} alt="" />
                </div>
                <div className="subNumber">
                  <span>01</span>
                </div>
                <div className="textWrap flex-col gap-16">
                  <div className="mainNumber">
                    <span>01</span>
                  </div>
                  <div className="title">
                    <span>
                      설계부터 이관, 운영까지
                      <br />
                      클라우드 전 과정 지원
                    </span>
                  </div>
                  <div className="divide"></div>
                  <div className="description">
                    <span>
                      CSP 전환, 아키텍쳐 설계, 보안·모니터링까지 통합 서비스를
                      제공 합니다.
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid-item py-20 px-20 left">
                <div className="imgWrap">
                  <img src={crossCard2} alt="" />
                </div>
                <div className="subNumber">
                  <span>02</span>
                </div>
                <div className="textWrap flex-col gap-16">
                  <div className="mainNumber">
                    <span>02</span>
                  </div>
                  <div className="title">
                    <span>
                      고성능·고신뢰
                      <br />
                      데이터센터 기반 서비스 운영
                    </span>
                  </div>
                  <div className="divide"></div>
                  <div className="description ">
                    <span>
                      안정적인 인프라 환경과 이중화 설비를 기반으로 안정적인 IDC
                      서비스를 제공 합니다.
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid-item py-20 px-20 center">
                <div className="imgWrap">
                  <img src={crossCard3} alt="" />
                </div>
                <div className="subNumber">
                  <span>03</span>
                </div>
                <div className="textWrap flex-col gap-16">
                  <div className="mainNumber">
                    <span>03</span>
                  </div>
                  <div className="title">
                    <span>
                      고도화된 보안 인프라와
                      <br />
                      DDoS 대응 체계 구축
                    </span>
                  </div>
                  <div className="divide"></div>
                  <div className="description">
                    <span>
                      실시간 트래픽 분석과 전용 방어 장비를 통해 사이버
                      위협으로부터 고객 자산을 보호 합니다.
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid-item py-20 px-20 right">
                <div className="imgWrap">
                  <img src={crossCard4} alt="" />
                </div>
                <div className="subNumber">
                  <span>04</span>
                </div>
                <div className="textWrap flex-col gap-16">
                  <div className="mainNumber">
                    <span>04</span>
                  </div>
                  <div className="title">
                    <span>
                      국내 주요 통신사 연동으로
                      <br />
                      최적의 네트워크 품질 보장
                    </span>
                  </div>
                  <div className="divide"></div>
                  <div className="description">
                    <span>
                      멀티 ISP 구성으로 대역폭 확보와 장애 대응에 유리한
                      네트워크 환경을 제공 합니다.
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid-item py-20 px-20 bottom">
                <div className="imgWrap">
                  <img src={crossCard5} alt="" />
                </div>
                <div className="subNumber">
                  <span>05</span>
                </div>
                <div className="textWrap flex-col gap-16">
                  <div className="mainNumber">
                    <span>05</span>
                  </div>
                  <div className="title">
                    <span>
                      서버·네트워크·클라우드
                      <br />
                      전담 엔지니어의 실시간 대응
                    </span>
                  </div>
                  <div className="divide"></div>
                  <div className="description">
                    <span>
                      365일 운영되는 전문 기술팀의 모니터링과 지원으로 안정적인
                      서비스 유지가 가능 합니다.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="historySection flex-col align-center justify-center">
        <div className="grid flex-col tab:gap-80 gap-128 align-center justify-center">
          <div className="flex-col tab:align-start  gap-32 align-center justify-center">
            <div className="divide"></div>
            <div
              data-aos="fade"
              data-aos-delay="100"
              data-aos-offset="0"
              className="textWrap flex-col  gap-32 justify-center align-center"
            >
              <div className="main tab:text-start">
                <span>디엔에이클라우드가 걸어온 길을 소개합니다.</span>
              </div>
            </div>
          </div>
          <div className={`history ${isHistory ? 'active' : ''}`}>
            <div
              className={`fixYear flex-row gap-24 align-center ${isHistory ? 'active' : ''} ${isHistoryLastDirection}`}
            >
              <span>{currentYear}</span>
            </div>
            <div className="issueList flex-col gap-256 tab:gap-80">
              {historyData.map((data, i) => (
                <div
                  className={`tab:flex-col tab:gap-40  issueWrap ${currentYearIndex === i + 1 ? 'active' : ''}`}
                  key={data.year}
                >
                  <div className="year">
                    <span>{data.year}</span>
                  </div>
                  <div className="issuesBox  flex-col gap-80 tab:gap-20 align-end">
                    {data.issues.map((issue, j) => (
                      <div
                        className={`
                          issueItem flex-row gap-24 align-start justify-start  ${issue?.accent === true ? ' accent' : ''}
                        `}
                        // style={{ transform: `translateY(${j * 32}%)` }}
                        key={j}
                      >
                        <div className="month">
                          <span>{issue.month}</span>
                        </div>
                        <div className="issue">
                          <span>{issue.content}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="sloganSection  flex-col py-128 justify-center align-center"
      >
        <div className="grid flex-col gap-96">
          <div className="sloganWrap flex-col gap-48">
            <div className="sloganTitle">
              <span>
                <strong className={'strongA viewOne'}>Your </strong>
                <strong className={'strongB viewTwo'}>Trusted Partner</strong>
                <br />
                <strong className={'strongA viewThree'}>in</strong>
                <strong className={'strongC viewFour'}>
                  Digital Transformation
                </strong>
              </span>
            </div>
            <div className="description">
              <span>
                믿을 수 있는 파트너,
                <br />
                <strong>디엔에이클라우드와 함께</strong> 최상의 서비스를
                경험해보세요
              </span>
            </div>
            <div className="roundBtn flex-col justify-center align-center px-40">
              <Link to={'/contact'}>
                <span>CONTACT US</span>
              </Link>
            </div>
          </div>
          <div className="flex-col flex-full gap-40 justify-between align-center">
            <div className="companyInfoWrap flex-row flex-full justify-center gap-12">
              <div className="addressInfo flex-row align-center gap-4">
                <div className="iconWrap flex-row align-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#000000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                    <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                  </svg>
                </div>
                <span>서울 성동구 성수일로 99 서울숲AK밸리 506호</span>
              </div>
              <div className="contactInfo  flex-row align-center gap-4">
                <div className="iconWrap  flex-row align-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#000000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                  </svg>
                </div>
                <span>02-6406-6100</span>
              </div>
            </div>
            <div className="mapWrap  flex-full">
              <KakaoMapWithAddress
                address={'서울 성동구 성수일로 99'}
                viewAddress={'서울숲AK밸리 506호'}
              />
              {/*<iframe*/}
              {/*  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.6642192849076!2d127.01542862621277!3d37.515836977033146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3c2a48366f5%3A0x8d757ca508fe0c3a!2z6riI7IKw67mM65Sp!5e0!3m2!1sko!2skr!4v1743501968784!5m2!1sko!2skr"*/}
              {/*  style={{ border: 0, width: '100%', height: '100%' }}*/}
              {/*  loading="lazy"*/}
              {/*  allowFullScreen=""*/}
              {/*  referrerPolicy="no-referrer-when-downgrade"*/}
              {/*></iframe>*/}
            </div>
            <div className="locationListWrap flex-col gap-16 ">
              <div className="locationList flex-col gap-16">
                <div className="item flex-row gap-8">
                  <div className="label">
                    <span>지하철</span>
                  </div>
                  <div className="detailItem flex-col gap-16">
                    <div className="contents">
                      <span>
                        <strong className={'subway'}>② </strong>뚝섬역 하차
                        (4번출구로부터 도보 12분)
                      </span>
                    </div>
                  </div>
                </div>
                <div className="item flex-row gap-8">
                  <div className="label">
                    <span>버스</span>
                  </div>
                  <div className="detailItem flex-col gap-16">
                    <div className="contens">
                      <span>
                        <strong>302번 </strong>리버하우스 정류장 하차
                      </span>
                    </div>
                    <div className="contens">
                      <span>
                        <strong>2012번 </strong>리버하우스 정류장 하차
                      </span>
                    </div>
                    <div className="contens">
                      <span>
                        <strong>463번 </strong>뚝섬서울숲 정류장 하자
                      </span>
                    </div>
                    <div className="contens">
                      <span>
                        <strong>2222번 </strong>리버하우스 정류장 하차
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyMain;
